export default "__VITE_ASSET__BL4lCpF4__"